"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var Dates_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.toMap = exports.snapDate = exports.snapActions = exports.minutesBetweenDates = exports.getWeekStart = exports.getRelativeHumanReadableAge = exports.getHoursAgo = exports.Dates = void 0;
const debuggable_1 = require("@krauters/debuggable");
const logger_1 = require("@krauters/logger");
const strings_1 = require("./strings");
const structures_1 = require("./structures");
let Dates = class Dates {
    static { Dates_1 = this; }
    static snapActions = {
        [structures_1.SnapType.Day]: (date) => {
            date.setUTCHours(0, 0, 0, 0);
        },
        [structures_1.SnapType.Hour]: (date) => {
            date.setUTCMinutes(0, 0, 0);
        },
        [structures_1.SnapType.Minute]: (date) => {
            date.setUTCSeconds(0, 0);
        },
        [structures_1.SnapType.Month]: (date) => {
            date.setUTCDate(1);
            date.setUTCHours(0, 0, 0, 0);
        },
        [structures_1.SnapType.Second]: (date) => {
            date.setUTCSeconds(0, 0);
        },
        [structures_1.SnapType.Week]: (date) => {
            date.setUTCDate(date.getUTCDate() - date.getUTCDay());
            date.setUTCHours(0, 0, 0, 0);
        },
        [structures_1.SnapType.Year]: (date) => {
            date.setUTCMonth(0, 1);
            date.setUTCHours(0, 0, 0, 0);
        },
    };
    static getHoursAgo(date) {
        const millisecondsDifference = Date.now() - date.valueOf();
        return Math.floor(millisecondsDifference / (1000 * 60 * 60));
    }
    static getRelativeAge(hoursAgo, withAgo = true) {
        const agoSuffix = withAgo ? ' ago' : '';
        if (hoursAgo < 1) {
            return 'in the last hour';
        }
        else if (hoursAgo < 24) {
            return `${hoursAgo} ${(0, strings_1.plural)('hour', hoursAgo)}${agoSuffix}`;
        }
        const daysAgo = Math.floor(hoursAgo / 24);
        return `${daysAgo} ${(0, strings_1.plural)('day', daysAgo)}${agoSuffix}`;
    }
    static getWeekStart(date = new Date()) {
        return Dates_1.snapDate(date, { snap: structures_1.SnapType.Week });
    }
    static minutesBetweenDates(date1, date2) {
        const millisecondsPerMinute = 1000 * 60;
        const differenceInMilliseconds = date2.getTime() - date1.getTime();
        return Math.floor(Math.abs(differenceInMilliseconds / millisecondsPerMinute));
    }
    static snapDate(date, { days, months, snap = structures_1.SnapType.Day } = {}) {
        const result = new Date((date ?? new Date()).getTime());
        result.setUTCMonth(result.getUTCMonth() + (months ?? 0));
        result.setUTCDate(result.getUTCDate() + (days ?? 0));
        if (snap && Dates_1.snapActions[snap]) {
            Dates_1.snapActions[snap](result);
        }
        return result;
    }
    static toMap(date) {
        return {
            date: date.getUTCDate(),
            day: date.getUTCDay(),
            hours: date.getUTCHours(),
            isoString: date.toISOString(),
            milliseconds: date.getUTCMilliseconds(),
            minutes: date.getUTCMinutes(),
            month: date.getUTCMonth() + 1,
            seconds: date.getUTCSeconds(),
            time: date.getTime(),
            timezoneOffset: date.getTimezoneOffset(),
            utcDate: date.getUTCDate(),
            utcDay: date.getUTCDay(),
            utcFullYear: date.getUTCFullYear(),
            utcHours: date.getUTCHours(),
            utcMilliseconds: date.getUTCMilliseconds(),
            utcMinutes: date.getUTCMinutes(),
            utcMonth: date.getUTCMonth(),
            utcSeconds: date.getUTCSeconds(),
            year: date.getUTCFullYear(),
        };
    }
};
exports.Dates = Dates;
exports.Dates = Dates = Dates_1 = __decorate([
    (0, debuggable_1.debuggable)(logger_1.log)
], Dates);
exports.getHoursAgo = Dates.getHoursAgo, exports.getRelativeHumanReadableAge = Dates.getRelativeAge, exports.getWeekStart = Dates.getWeekStart, exports.minutesBetweenDates = Dates.minutesBetweenDates, exports.snapActions = Dates.snapActions, exports.snapDate = Dates.snapDate, exports.toMap = Dates.toMap;
//# sourceMappingURL=dates.js.map